import awards from "../../shared/uk.awards";
import branded_quotes from "../../shared/uk.branded-quotes";
import verticals from "./uk-education-primary.verticals";

const pageFooter = ({ strings }) => {
    return {
        awards: {
            visible: true,
            title: {
                content: strings.awards_header_label,
                align: "center",
                type: "section-title"
            },
            panels: awards({ strings })
        },
        branded_quotes: {
            visible: true,
            title: {
                content: strings.branded_quotes_header_label,
                align: "center",
                type: "section-title"
            },
            panels: branded_quotes({ strings })
        },
        verticals: {
            visible: true,
            title: {
                content: strings.verticals_label,
                align: "center",
                type: "section-title"
            },
            panels: verticals({ strings })
        }
    };
};

export default ({ page, strings }) => {
    switch (page) {
        case "uk-education-primary-404":
            return {
                page,
                helmet: {
                    meta_title: "Page Not Found | Rosetta Stone",
                    meta_description: "",
                    canonical_url: "https://www.rosettastone.co.uk/schools/404",
                    lang: "en"
                },
                ...pageFooter({ strings })
            };
        case "uk-education-primary-contact":
            return {
                page,
                helmet: {
                    meta_title: "Contact | Rosetta Stone",
                    meta_description:
                        "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                    canonical_url: "https://www.rosettastone.co.uk/schools/contact/",
                    lang: "en"
                },
                ...pageFooter({ strings })
            };
        case "uk-education-primary-dynamic-resources":
            return {
                page,
                helmet: {
                    meta_title: "",
                    meta_description: "",
                    canonical_url: "",
                    lang: "en"
                },
                eloquaPage: "resources",
                ...pageFooter({ strings })
            };
        case "uk-education-primary-dynamic-content":
            return {
                page,
                helmet: {
                    meta_title: "",
                    meta_description: "",
                    canonical_url: "",
                    lang: "en"
                },
                eloquaPage: "resources",
                ...pageFooter({ strings })
            };
        case "uk-education-primary-home":
            return {
                page,
                helmet: {
                    meta_title: "Digital Language Learning for Schools | Rosetta Stone",
                    meta_description:
                        "Rosetta Stone digital language learning for schools integrates easily into classrooms and any language programme. Ask us about pricing.",
                    canonical_url: "https://www.rosettastone.co.uk/schools/",
                    lang: "en"
                },
                ...pageFooter({ strings })
            };
        case "uk-education-primary-solutions":
            return {
                page,
                helmet: {
                    meta_title: "Online Language Learning Education Programs  | Rosetta Stone",
                    meta_description:
                        "Rosetta Stone online programs support language learners in schools, higher education, and teacher training. Learn how, and ask about education pricing.",
                    canonical_url: "https://www.rosettastone.co.uk/schools/solutions/",
                    lang: "en"
                },
                ...pageFooter({ strings })
            };
        default:
            return null;
    }
};
